import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "@/hooks/translation";
import { ShareLink } from '@/icons';
import Button from '../../Button';
import styles from './copyLink.module.scss';

const CopyLink = ({ url }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { t } = useTranslation();

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1000);
  }

  return (
    <>
      <Button iconButton className={styles.copyLinkButton} onClick={handleCopyLink}>
        <ShareLink />
      </Button>
      {showTooltip && (
        <p className={styles.tooltip}>{t("articles.social_share.copy_link")}</p>
      )}
    </>
  );
}

export default CopyLink;

CopyLink.propTypes = {
  url: PropTypes.string,
}
